import { render } from "./DashboardAdministration.vue?vue&type=template&id=bc446906&scoped=true"
import script from "./DashboardAdministration.vue?vue&type=script&lang=js"
export * from "./DashboardAdministration.vue?vue&type=script&lang=js"

import "./DashboardAdministration.vue?vue&type=style&index=0&id=bc446906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc446906"]])

export default __exports__